import React from "react";
import { FeaturedSectionTemplate } from "themes/administration/naki-mobile/pages";
import { FeaturedSectionViewStore } from "administration/naki-mobile/stores";
import { setCurrentView } from "mrb/core";
import { observer } from "mobx-react";

@setCurrentView(
    (rootStore, componentProps) => new FeaturedSectionViewStore(rootStore, componentProps),
    "featuredSectionViewStore"
)
@observer
class FeaturedSection extends React.Component {
    render() {
        return <FeaturedSectionTemplate {...this.props} />;
    }
}

export default FeaturedSection;
